function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nodeFill-1,.nodeFill-5{fill:url(#linear-gradient);}.nodeFill-1{clip-rule:evenodd;}.nodeFill-2,.nodeFill-4{fill:#679e63;}.nodeFill-3{fill:#fff;}.nodeFill-3,.nodeFill-4,.nodeFill-5{fill-rule:evenodd;}.nodeFill-6{clip-path:url(#clip-path);}.nodeFill-7{fill:none;}.nodeFill-8{fill:url(#linear-gradient-3);}.nodeFill-9{fill:url(#linear-gradient-4);}.nodeFill-10{fill:url(#linear-gradient-5);}.nodeFill-11{fill:url(#linear-gradient-6);}.nodeFill-12{fill:url(#linear-gradient-7);}.nodeFill-13{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 258.7,
  y1: 244.71,
  x2: 220.64,
  y2: 322.37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3f873f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#3f8b3d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#3e9637"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#3da92e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3dae2b"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(-78.31 -164.02)"
}, /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-1",
  d: "M244.12,226.61a5.09,5.09,0,0,0-5.09,0L196.9,250.92a5.09,5.09,0,0,0-2.55,4.41V304a5.08,5.08,0,0,0,2.55,4.4L239,332.74a5.09,5.09,0,0,0,5.09,0l42.13-24.34a5.09,5.09,0,0,0,2.54-4.4V255.33a5.09,5.09,0,0,0-2.55-4.41Z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 235.16,
  y1: 285.35,
  x2: 341.96,
  y2: 206.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#3f873f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#529f44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#63b649"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#6abf4b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 114.56,
  y1: 53.82,
  x2: 211.97,
  y2: 53.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#6abf4b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#63b649"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#529f44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#3f873f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 192.86,
  y1: 279.65,
  x2: 290.28,
  y2: 279.65,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 114.56,
  y1: 143.45,
  x2: 211.97,
  y2: 143.45,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 192.86,
  y1: 320.03,
  x2: 290.28,
  y2: 320.03,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 304.47,
  y1: 242.41,
  x2: 244.39,
  y2: 364.98,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "nodejs-new-pantone-white");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-2",
  d: "M297,434.94a8.38,8.38,0,0,1-4.19-1.12l-13.34-7.89c-2-1.11-1-1.51-.36-1.74a26.25,26.25,0,0,0,6-2.74,1,1,0,0,1,1,.08l10.24,6.08a1.3,1.3,0,0,0,1.24,0l39.95-23.06a1.26,1.26,0,0,0,.61-1.08v-46.1a1.28,1.28,0,0,0-.62-1.1l-39.93-23a1.23,1.23,0,0,0-1.23,0l-39.93,23a1.28,1.28,0,0,0-.63,1.1v46.1a1.22,1.22,0,0,0,.63,1.07l10.94,6.32c5.94,3,9.58-.53,9.58-4V361.3a1.15,1.15,0,0,1,1.16-1.15h5.06a1.15,1.15,0,0,1,1.16,1.15v45.52c0,7.93-4.31,12.47-11.83,12.47-2.31,0-4.12,0-9.2-2.5l-10.48-6a8.46,8.46,0,0,1-4.19-7.29v-46.1a8.42,8.42,0,0,1,4.19-7.28L292.76,327a8.76,8.76,0,0,1,8.4,0l39.95,23.09a8.43,8.43,0,0,1,4.19,7.28v46.1a8.47,8.47,0,0,1-4.19,7.29l-39.95,23.06A8.4,8.4,0,0,1,297,434.94Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-2",
  d: "M309.29,403.18c-17.48,0-21.14-8-21.14-14.75a1.14,1.14,0,0,1,1.15-1.15h5.17a1.15,1.15,0,0,1,1.15,1c.78,5.26,3.1,7.92,13.67,7.92,8.42,0,12-1.91,12-6.37,0-2.58-1-4.49-14.09-5.77-10.93-1.08-17.69-3.5-17.69-12.24,0-8.06,6.79-12.87,18.18-12.87,12.8,0,19.13,4.44,19.93,14a1.15,1.15,0,0,1-.3.88,1.17,1.17,0,0,1-.85.37h-5.18a1.15,1.15,0,0,1-1.12-.9c-1.25-5.53-4.27-7.3-12.48-7.3-9.19,0-10.26,3.2-10.26,5.6,0,2.9,1.26,3.75,13.67,5.39s18.11,3.92,18.11,12.55S322,403.18,309.29,403.18Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-2",
  d: "M366.9,354.83a7.7,7.7,0,1,1-7.7-7.7A7.72,7.72,0,0,1,366.9,354.83Zm-14.16,0a6.46,6.46,0,1,0,6.44-6.44A6.46,6.46,0,0,0,352.74,354.81Zm3.57-4.3h3c1,0,3,0,3,2.28a2,2,0,0,1-1.63,2.12c1.18.08,1.26.86,1.42,2a8.51,8.51,0,0,0,.45,2.28h-1.83c0-.41-.33-2.61-.33-2.73-.12-.49-.29-.73-.9-.73H358v3.46h-1.67Zm1.63,3.79h1.34a1.16,1.16,0,0,0,1.31-1.22c0-1.18-.82-1.18-1.27-1.18h-1.38Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-3",
  d: "M173.24,254.57a5.11,5.11,0,0,0-2.56-4.45l-42.35-24.37a5.11,5.11,0,0,0-2.33-.68h-.44a5.18,5.18,0,0,0-2.34.68L80.87,250.12a5.14,5.14,0,0,0-2.56,4.45l.09,65.63a2.51,2.51,0,0,0,1.28,2.21,2.46,2.46,0,0,0,2.54,0L107.39,308a5.17,5.17,0,0,0,2.56-4.44V272.89a5.1,5.1,0,0,1,2.55-4.42l10.72-6.18a5.1,5.1,0,0,1,2.57-.68,5,5,0,0,1,2.54.68l10.72,6.18a5.1,5.1,0,0,1,2.55,4.42v30.67a5.17,5.17,0,0,0,2.57,4.44l25.16,14.41a2.5,2.5,0,0,0,2.56,0,2.56,2.56,0,0,0,1.27-2.21Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-3",
  d: "M377,164.34a2.56,2.56,0,0,0-3.8,2.23v65a1.82,1.82,0,0,1-.9,1.56,1.79,1.79,0,0,1-1.79,0L359.94,227a5.1,5.1,0,0,0-5.11,0l-42.37,24.45a5.09,5.09,0,0,0-2.56,4.43v48.92a5.12,5.12,0,0,0,2.56,4.43l42.37,24.47a5.12,5.12,0,0,0,5.11,0l42.38-24.47a5.14,5.14,0,0,0,2.56-4.43V182.88a5.11,5.11,0,0,0-2.63-4.47Zm-3.93,124.4a1.27,1.27,0,0,1-.64,1.11l-14.55,8.39a1.32,1.32,0,0,1-1.28,0l-14.54-8.39a1.27,1.27,0,0,1-.64-1.11v-16.8a1.28,1.28,0,0,1,.63-1.1l14.55-8.41a1.27,1.27,0,0,1,1.28,0l14.55,8.41a1.27,1.27,0,0,1,.64,1.1Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-3",
  d: "M518.13,271.5a5.1,5.1,0,0,0,2.55-4.42V255.23a5.12,5.12,0,0,0-2.55-4.43L476,226.36a5.14,5.14,0,0,0-5.13,0l-42.35,24.46a5.09,5.09,0,0,0-2.56,4.43v48.9a5.12,5.12,0,0,0,2.58,4.44l42.1,24a5.13,5.13,0,0,0,5,0l25.46-14.15a2.56,2.56,0,0,0,0-4.46l-42.62-24.46a2.57,2.57,0,0,1-1.29-2.22V272a2.55,2.55,0,0,1,1.28-2.21l13.27-7.65a2.53,2.53,0,0,1,2.55,0l13.28,7.65a2.55,2.55,0,0,1,1.28,2.21V284a2.55,2.55,0,0,0,3.84,2.21Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-4",
  d: "M472.84,269.21a1,1,0,0,1,1,0L482,273.9a1,1,0,0,1,.5.86v9.38a1,1,0,0,1-.5.85l-8.13,4.7a1,1,0,0,1-1,0l-8.12-4.7a1,1,0,0,1-.49-.85v-9.38a1,1,0,0,1,.49-.86Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-5",
  d: "M244.12,226.61a5.09,5.09,0,0,0-5.09,0L196.9,250.92a5.09,5.09,0,0,0-2.55,4.41V304a5.08,5.08,0,0,0,2.55,4.4L239,332.74a5.09,5.09,0,0,0,5.09,0l42.13-24.34a5.09,5.09,0,0,0,2.54-4.4V255.33a5.09,5.09,0,0,0-2.55-4.41Z",
  transform: "translate(-78.31 -164.02)"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  className: "nodeFill-6"
}, /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-7",
  d: "M238.94,226.61l-42.22,24.31a5.27,5.27,0,0,0-2.72,4.41V304a4.9,4.9,0,0,0,1.31,3.23l47.44-81.15A5.19,5.19,0,0,0,238.94,226.61Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-7",
  d: "M243,333.23a5.07,5.07,0,0,0,1.18-.49l42.18-24.34A5.2,5.2,0,0,0,289,304V255.33a5.05,5.05,0,0,0-1.54-3.54Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-8",
  d: "M286.33,250.92l-42.25-24.31a5.07,5.07,0,0,0-1.33-.53l-47.44,81.15a5.91,5.91,0,0,0,1.42,1.17l42.33,24.34a5.15,5.15,0,0,0,3.93.49l44.47-81.44A6,6,0,0,0,286.33,250.92Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-7",
  d: "M289,304V255.33a5.22,5.22,0,0,0-2.67-4.41l-42.25-24.31a5,5,0,0,0-1.56-.57l46.32,79.12A4.51,4.51,0,0,0,289,304Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-7",
  d: "M196.72,250.92a5.27,5.27,0,0,0-2.72,4.41V304a5.28,5.28,0,0,0,2.73,4.4l42.33,24.34a5.14,5.14,0,0,0,3.25.63L197,250.78Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "nodeFill-9",
  points: "159.32 53.65 158.74 53.98 159.51 53.98 159.32 53.65"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-10",
  d: "M286.35,308.4a5.32,5.32,0,0,0,2.49-3.24L242.52,226a5.16,5.16,0,0,0-3.58.57l-42,24.17,45.33,82.59a5.19,5.19,0,0,0,1.86-.63Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "nodeFill-11",
  points: "211.97 143.6 211.69 143.13 211.69 143.76 211.97 143.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-12",
  d: "M286.35,308.4l-42.18,24.34a5.19,5.19,0,0,1-1.86.63l.84,1.53L290,307.78v-.64l-1.16-2A5.32,5.32,0,0,1,286.35,308.4Z",
  transform: "translate(-78.31 -164.02)"
}), /*#__PURE__*/React.createElement("path", {
  className: "nodeFill-13",
  d: "M286.35,308.4l-42.18,24.34a5.19,5.19,0,0,1-1.86.63l.84,1.53L290,307.78v-.64l-1.16-2A5.32,5.32,0,0,1,286.35,308.4Z",
  transform: "translate(-78.31 -164.02)"
}));

var SvgNodejs = function SvgNodejs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 442.37 270.93",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNodejs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nodejs.76cdd078.svg";
export { ForwardRef as ReactComponent };